import React from "react";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/data/content";
import { MegaphoneSimple, PenNib, VideoCamera, Camera, ChatCircleDots, Globe } from "@phosphor-icons/react";

const SERVICES = [
  { icon: MegaphoneSimple, title: "Social Media Management", desc: "Consistent, on-brand presence across the platforms your audience actually uses." },
  { icon: PenNib, title: "Graphic & Brand Design", desc: "Logos, brand identity systems and post design that make you unmistakable." },
  { icon: VideoCamera, title: "Video & Reels", desc: "Short-form video and edited content built to stop the scroll." },
  { icon: Camera, title: "Photography", desc: "Professional in-person sessions that give your brand a premium look." },
  { icon: ChatCircleDots, title: "SMS Campaigns", desc: "Direct-to-customer messaging campaigns that drive real engagement." },
  { icon: Globe, title: "Website Design", desc: "Elegant, conversion-focused websites and ongoing maintenance." },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="py-24 md:py-36 bg-[#0A1521]">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end mb-20">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">What We Do</p>
            <h2 className="font-heading font-light text-4xl sm:text-5xl lg:text-6xl text-[#F6F4F0] leading-tight">
              A complete social media team, without the overhead.
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-5">
          <Reveal delay={0.1}>
            <p className="text-[#E5E7EB] font-light leading-relaxed">
              Social media is at the heart of everything we do — from strategy and content to reels, photography and reporting, we handle it all so you can focus on running your business.
            </p>
          </Reveal>
        </div>
      </div>

      {/* Spotlight image row — clipped editorial frames */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-20">
        <Reveal>
          <div className="relative overflow-hidden group h-80">
            <img src={IMAGES.social} alt="Social media content" className="w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0D1B2A] via-transparent to-transparent" />
            <span className="absolute bottom-6 left-6 font-heading text-2xl text-[#F6F4F0]">Social & Content</span>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="relative overflow-hidden group h-80">
            <img src={IMAGES.photography} alt="Photography studio" className="w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0D1B2A] via-transparent to-transparent" />
            <span className="absolute bottom-6 left-6 font-heading text-2xl text-[#F6F4F0]">Photo & Video</span>
          </div>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#F6F4F0]/10 border border-[#F6F4F0]/10">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={(i % 3) * 0.08}>
            <div data-testid={`service-card-${i}`} className="h-full bg-[#0D1B2A] p-10 hover:bg-[#101f30] transition-colors duration-300 group">
              <s.icon size={34} weight="thin" className="text-gold mb-8" />
              <h3 className="font-heading text-2xl text-[#F6F4F0] mb-3 group-hover:text-gold transition-colors">{s.title}</h3>
              <p className="text-[#E5E7EB] font-light text-sm leading-relaxed">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
